// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__nhlTh","head":"ProcedureTableInfo_head___4IW5"};